import { Fragment } from 'react';

import { DeleteIcon } from '@braskai/icons';
import { Divider, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';
import { DOTS_MENU_MODE, DotsMenu } from '@/shared/ui/DotsMenu';

import { Member } from '../lib/types';

type MemberListProps = {
  email?: string;
  isOwner: boolean;
  members: Member[];
  onDelete: (email: string) => void;
};

export const MemberList = ({ email, isOwner, members, onDelete }: MemberListProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Stack>
      {members.map((member) => (
        <Fragment key={member.email}>
          <Stack alignItems="center" direction="row" gap={8} height="46px" justifyContent="space-between">
            <Typography color="grey.700" maxLines={1} variant="body-1">
              {member.email}
            </Typography>
            <Stack direction="row">
              <Typography color="grey.700" flexShrink={0} variant="body-1">
                {member.role === 'owner' ? t('teamspace.member.owner') : t('teamspace.member.editor')}
                {member.email === email ? (
                  <Typography color="grey.500" variant="body-1">
                    {' '}
                    {t('teamspace.member.you')}
                  </Typography>
                ) : null}
              </Typography>
              {member.email !== email && isOwner ? (
                <DotsMenu
                  options={[
                    {
                      id: 'remove',
                      label: t('teamspace.action.remove'),
                      action: () => onDelete(member.email || ''),
                      icon: <DeleteIcon height={20} width={20} />,
                      testId: 'teamspace-menu-remove-member',
                    },
                  ]}
                  type={DOTS_MENU_MODE.vertical}
                />
              ) : null}
            </Stack>
          </Stack>
          <Divider />
        </Fragment>
      ))}
    </Stack>
  );
};
